import { Pipe, PipeTransform } from '@angular/core';
import { currencyParser } from '../helpers/currency-parser';
import { calcDiscountedPrice } from '../helpers/price-helper';

@Pipe({
  standalone: false,
  name: 'tryToDiscountPrice'
})
export class TryToDiscountPricePipe implements PipeTransform {
  public transform(item: any, discount = 0, prefix = '') {
    if (discount) {
      return currencyParser(calcDiscountedPrice(item, discount), prefix);
    }

    return currencyParser(item, prefix);
  }
}
